import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'shop', en);
i18next.addResources('fr', 'shop', fr);

declare global {
  interface RegisteredLocales {
    shop: typeof en;
  }
}
